import { Rocket } from 'lucide-react';
import { useLaunchDashboardStore } from '@/stores/launch-dashboard-store';
import { cn } from '@/lib/utils';

/** HUD chip that opens the full-screen Launch Dashboard. */
export function LaunchDashboardControl(): React.JSX.Element {
  const open = useLaunchDashboardStore((s) => s.open);
  const toggle = useLaunchDashboardStore((s) => s.toggle);

  return (
    <button
      type="button"
      onClick={toggle}
      title="Launch Dashboard"
      className={cn(
        'flex items-center gap-2 rounded-lg border px-2.5 py-2 shadow-lg backdrop-blur transition-colors',
        open ? 'border-echo-yellow bg-echo-yellow/20' : 'border-echo-border bg-echo-grey/90 hover:border-echo-border/80',
      )}
    >
      <Rocket className={cn('h-4 w-4', open ? 'text-echo-yellow' : 'text-muted-foreground')} />
      <span className="font-chakra text-xs font-semibold uppercase tracking-wider text-foreground">Launches</span>
    </button>
  );
}
